module.exports = __webpack_public_path__ + "static/media/flagged-white.66c6b5fa.svg";